import { Map } from 'immutable'

export function selectIsBreakpoint (breakpoint) {
  return (state) => {
    const hydrationComplete = state.app.get('bootstrapComplete')
    const viewport = state.app.getIn(['viewport', 'width'], 0)
    return hydrationComplete && viewport < breakpoint
  }
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export const selectIsTouchable = (state) => state.app.getIn(['viewport', 'touchable'], false)

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export const selectApp = (state) => state.app || Map()

/**
 * @param {ReduxState} state redux state
 * @returns {Number}
 */
export const selectAppViewportWidth = (state) => selectApp(state).getIn(['viewport', 'width'], 0)

/**
 * @param {ReduxState} state redux state
 * @returns {Number}
 */
export const selectAppViewportHeight = (state) => selectApp(state).getIn(['viewport', 'height'], 0)
